import { render, staticRenderFns } from "./_ibcMatch.vue?vue&type=template&id=13ecf15e&scoped=true&lang=pug&"
import script from "./_ibcMatch.vue?vue&type=script&lang=js&"
export * from "./_ibcMatch.vue?vue&type=script&lang=js&"
import style0 from "./_ibcMatch.vue?vue&type=style&index=0&id=13ecf15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ecf15e",
  null
  
)

export default component.exports